import { render, staticRenderFns } from "./contractInstall-list.vue?vue&type=template&id=5c45e3b4"
import script from "./contractInstall-list.vue?vue&type=script&lang=js"
export * from "./contractInstall-list.vue?vue&type=script&lang=js"
import style0 from "./contractInstall-list.vue?vue&type=style&index=0&id=5c45e3b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports